import React from "react";

import PageTitleNew from "../../ui/PageTitleNew";
import Main from "./Main";

import Context from "./Context";
import ManagerPolicyContext from "../../../contexts/ManagerPolicyContext";
import PolicyContext from "../Policy/Context";
import CountryContext from "contexts/CountryContext";

export default function Index({ enterpriseId }) {
  return (
    <Context enterpriseId={enterpriseId}>
      <ManagerPolicyContext enterpriseId={enterpriseId}>
        <PolicyContext enterpriseId={enterpriseId}>
          <CountryContext>
            <div className="wrapper_assestment invite_wrapper">
              <PageTitleNew title="Billing" />

              <Main />
            </div>
          </CountryContext>
        </PolicyContext>
      </ManagerPolicyContext>
    </Context>
  );
}
